import { Injectable } from '@angular/core';
import { AvailableMapsFieldModel } from '../../models/availableMapsFieldModel';

@Injectable({
  providedIn: 'root',
})
export class CustomSequenceService {
  private selectedItems: AvailableMapsFieldModel[] = [];

  getSelectedItems(): AvailableMapsFieldModel[] {
    return this.selectedItems;
  }

  setSelectedItems(items: AvailableMapsFieldModel[]): void {
    this.selectedItems = [...items];
  }

  clearSelectedItems(): void {
    this.selectedItems = [];
  }
}
